/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Grid, InputAdornment, TextField} from "@mui/material";
import {Menu, Search} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {useAnimate} from "framer-motion";
import IconoAvatarPerfil from "./SubComponentes/IconoAvatarPerfil";
import {useMediaQuery} from "@mui/system";
import {theme} from "../../Tema";
import {useNavigate} from "react-router";

const Barra = ({setOpen, open, seccionesPerfil}) => {
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const navigate = useNavigate();
    const [navegando, setNavegando] = useState(false)
    const [scope, animate] = useAnimate()
    const [opaco, setOpaco] = useState(1)
    const [openPerfil, setOpenPerfil] = useState(false)
    const [openPerfilNotificacion, setOpenPerfilNotificaciones] = useState(false)
    const [palabra, setPalabra] = useState('')


    const sePresiono = (e) => {

        if (e.key === 'Enter') {
            // setOpen(false)
            navigate('/Resultados/' + palabra)
        }
    }


    useEffect(() => {


        window.addEventListener('scroll', (e) => {
            if (window.scrollY > 50 && !navegando) {
                setNavegando(true)
            } else if (window.scrollY < 50) {
                setNavegando(false)
            }

        });


        if (scope.current && masSM) {
            setOpaco(0)
            animate(scope.current, {x: -200, transitionDuration: 0})
            setTimeout(() => {
                setOpaco(1)
                if (scope.current) {
                    animate(scope.current, {x: 1, transitionDuration: 0})
                }

            }, 500)
        }


    }, [open]);
    return (
        <Grid
            container
            size={12}
            alignItems={'center'}
            sx={{
                px: masSM ? 4 : 3,
                py: 2,
                boxShadow: navegando ? 3 : 0,
                position: 'fixed',
                top: '0%',
                backgroundColor: '#fff',
                pr: open && masSM ? 36 : !masSM ? 3 : 13
            }}
        >

            <Grid size={{xs: 2, sm: 1, md: 1}}>
                <ButtonBase
                    onClick={() => setOpen((e) => !e)}
                >
                    <Menu/>
                </ButtonBase>

            </Grid>

            <Grid size={{xs: 8, sm: 10, md: 8}} sx={{ml: sCell ? -2 : 0, mr: sCell ? 2 : 0}}>
                {/*}  <TextField
                    label={'Barra de Busqueda'}
                    fullWidth={false}
                    size={'small'}
                    sx={{width: sCell ? '100%' : '40%'}}
                    onChange={(e) => setPalabra(e.target.value)}
                    value={palabra}
                    onKeyDown={(e) => sePresiono(e)}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Search
                                        onClick={() => navigate('/Resultados/' + palabra)}
                                        color={'primary'} sx={{p: 1, cursor: 'pointer'}}/>
                                </InputAdornment>
                            ),
                            disableUnderline: true,
                        },
                        inputLabel: {
                            sx: {marginLeft: 0}
                        }
                    }
                    }
                />*/}
            </Grid>

            <Grid
                ref={scope}
                container size={{xs: 2, sm: 1, md: 3}} justifyContent={'flex-end'} justifyItems={'center'}
                sx={{
                    opacity: opaco,
                    pr: (openPerfil || openPerfilNotificacion) && masSM ? 1.7 : 0,
                }}
                spacing={!masSM ? 1 : 6}
            >


                <Grid container size={{xs: 3, sm: 2, md: 2}} justifyContent={'flex-end'}>
                    {/*
                    <IconButton>
                        <WbSunnyOutlined color={'info'} sx={{width: 20, height: 20}}/>
                    </IconButton>
                    */}
                </Grid>

                <Grid container size={{xs: 3, sm: 2, md: 2}} justifyContent={'flex-end'}>
                    {/*
                    <IconoHistorial/>
                    */}
                </Grid>

                <Grid container size={{xs: 3, sm: 2, md: 2}} justifyContent={'flex-end'}>
                    {/* <IconoNotificaciones color={'info'} sx={{width: 20, height: 20}}
                                         setOpenPerfilNotificaciones={setOpenPerfilNotificaciones}
                                         openPerfilNotificacion={openPerfilNotificacion}/> */}
                </Grid>

                <Grid container size={{xs: 3, sm: 2, md: 2}} justifyContent={'flex-end'}
                >
                    <IconoAvatarPerfil openPerfil={openPerfil} setOpenPerfil={setOpenPerfil}
                                       seccionesPerfil={seccionesPerfil}/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Barra